import FormComponent_ from './FormComponent';
import FormItem_ from './FormItem';

export const FormComponent = FormComponent_;
export const FormItem = FormItem_;
